import React, { useEffect, useState } from "react";

/**
 * Floating WhatsApp chat button.
 *
 * Config (env, no hard-coding):
 *   REACT_APP_WHATSAPP_NUMBER    international format, digits only (e.g. 919327903300)
 *   REACT_APP_WHATSAPP_MESSAGE   optional pre-filled message
 */
const RAW_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "919327903300";
const MESSAGE =
  process.env.REACT_APP_WHATSAPP_MESSAGE ||
  "Hello PouchKart, I would like to enquire about your packaging products.";

// wa.me requires digits only — strip anything the user might have added.
const NUMBER = String(RAW_NUMBER).replace(/[^0-9]/g, "");
const HREF = `https://wa.me/${NUMBER}?text=${encodeURIComponent(MESSAGE)}`;

export default function WhatsAppFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after a short delay so it doesn't fight the hero animations.
    const t = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(t);
  }, []);

  if (!NUMBER) return null;

  return (
    <a
      href={HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-fab"
      className={`fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60]
                  inline-flex items-center gap-2 group
                  transition-all duration-300 ${
                    visible
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-2 pointer-events-none"
                  }`}
    >
      <span
        aria-hidden
        className="hidden md:inline-block bg-white border border-[#d1d5db] px-3 py-2
                   text-[11px] font-bold uppercase tracking-[0.16em] text-[#0a1128]
                   opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0
                   transition-all duration-200 shadow-sm"
      >
        Chat on WhatsApp
      </span>
      <span
        className="relative flex items-center justify-center
                   w-14 h-14 md:w-16 md:h-16 rounded-full
                   bg-[#25D366] hover:bg-[#1ebe5b]
                   text-white shadow-[0_10px_28px_-6px_rgba(37,211,102,0.55)]
                   transition-colors"
      >
        {/* Subtle pulse ring */}
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping"
        />
        {/* Official WhatsApp glyph */}
        <svg
          viewBox="0 0 32 32"
          width="28"
          height="28"
          className="relative"
          aria-hidden
        >
          <path
            fill="currentColor"
            d="M19.11 17.21c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35zM16.03 4.5C9.66 4.5 4.5 9.66 4.5 16.03c0 2.05.53 4.01 1.53 5.75L4.5 27.5l5.87-1.53a11.42 11.42 0 0 0 5.66 1.49h.01c6.36 0 11.53-5.17 11.53-11.53 0-3.08-1.2-5.98-3.38-8.16A11.46 11.46 0 0 0 16.03 4.5zm0 21.11h-.01a9.55 9.55 0 0 1-4.87-1.33l-.35-.21-3.49.91.93-3.4-.23-.36a9.56 9.56 0 0 1-1.47-5.09c0-5.28 4.3-9.58 9.58-9.58 2.56 0 4.96 1 6.77 2.81a9.53 9.53 0 0 1 2.8 6.77c0 5.28-4.3 9.58-9.66 9.58z"
          />
        </svg>
      </span>
    </a>
  );
}
